export const SCORE_FIELDS = [
  "AGE_XVALUE",
  "MINOR_SURGERY_XVALUE",
  "MAJOR_SURGERY_HISTORY_XVALUE",
  "INFLAMMATORY_BOWEL_DISE_XVALUE",
  "OBESITY_XVALUE",
  "LEG_SWELLING_PRESENCE_XVALUE",
  "ACUTE_MYOCARDIAL_INFECT_XVALUE",
  "CONJUNCTIVE_HEART_FAILU_XVALUE",
  "VARICOSE_VEINS_XVALUE",
  "SEPSIS_XVALUE",
  "PNEUMONIA_XVALUE",
  "ABNORMAL_BREATHING_TEST_XVALUE",
  "POST_BIRTH_XVALUE",
  "ORAL_CONTRACEPTIVE_REPL_XVALUE",
  "REPETITIVE_SPONTANEOUS_XVALUE",
  "BEDRIDDEN_MEDICAL_PATIE_XVALUE",
  "ARTHROSCOPIC_SURGERY_XVALUE",
  "MAJOR_OPEN_SURGERY_XVALUE",
  "LAPAROSCOPIC_SURGERY_XVALUE",
  "BEDRIDDEN_PATIENT_XVALUE",
  "IMMOBILIZATION_TO_PLAST_XVALUE",
  "CENTRAL_VENOUS_CATHETER_XVALUE",
  "VTE_HISTORY_XVALUE",
  "VTE_FAMILY_HISTORY_XVALUE",
  "FACTOR_V_LEIDEN_MUTATIO_XVALUE",
  "PROTHROMBINE_XVALUE",
  "LUPUS_ANTICOAGULANTS_XVALUE",
  "ANTICARDIOLIPIN_ANTIBOD_XVALUE",
  "HIGH_HOMOCYSTEINE_XVALUE",
  "STROKE_XVALUE",
  "MULTIPL_TRAUMA_XVALUE",
  "ACUTE_SPINAL_CORD_INJUR_XVALUE",
  "HPN_INDUCED_THROMBOCYTO_XVALUE",
  "OTHER_THROMBOPHILIAS_XVALUE",
  "ELTF_MJR_EXMY_ARTHROPLA_XVALUE",
  "HP_PELVIS_LEG_FRACTURE_XVALUE",
  "CANCER_XVALUE",
] as const;

export type ScoreFieldKey = typeof SCORE_FIELDS[number];



